import Toast from './components/toast/toast';
import Loader from './components/loader/loader';
import ScrollSmooth from "./animates/scroll-smooth";

export default class Soledis {
  constructor() {
    this.version = '1.0.0';
  }

  init() {
    // init toast
    const toast = new Toast();
    this.toast = toast;

    // init loader
    const loader = new Loader();
    this.loader = loader;

    // init scroll smooth
    const scrollSmooth = new ScrollSmooth();
    this.scrollSmooth = scrollSmooth;
  }
}
